<template>
    <div class="row m-0 button-row">
        <Action v-for="action in actions" :label="action.label" :type="action.type" :id="action.id"
                :action="action.action" :icon="action.icon" :class-markers="action.classMarkers" 
                :spinner-markers="action.spinnerMarkers" :hidden="action.hidden" 
                @emit-action="emitAction">
        </Action>
    </div>
</template>

<script>
    import Action from './Action.vue';
    
    export default {
        name: "ActionList",

        emits: ['do-login', 'do-new-user', 'do-oper-login', 'oper-login-cancel', 'add-method', 'cancel-add-method', 'send-code', 'send-code-cancel', 'verify-code', 'select-new-method', 'verify-code-cancel', 'exit-login', 'exit-to-login', 'validate-pii', 'validate-password-pii', 'validate-username-pii', 'validate-login-pii', 'cancel-pii', 'create-new-user', 'cancel-create-new-user', 'reset-password', 'cancel-reset-password', 'retrieve-user', 'setup-mfa-method', 'skip-mfa-login', 'accept-terms', 'decline-terms', 'broadcast-continue', 'continue-sfl', 'delete-sfl', 'skip-sfl', 'add-new-account', 'view-statements', 'portfolio', 'profileSettings', 'update-address', 'verify-address', 'cancel-address', 'contactInfo', 'add-phone', 'cancel-add-phone', 'changePhone', 'update-consent', 'cancel-consent', 'forget-all-devices', 'cancel-forget-all-devices', 'delete-method', 'cancel-delete-method', 'cancel-send-code', 'cancel-verify-code', 'mfaView', 'change-password', 'cancel-change-password', 'change-username', 'cancel-change-username', 'apply-doc-filter', 'delete-bank', 'cancel-delete-bank', 'add-bank', 'cancel-add-bank', 'deny-terms', 'keep-session', 'kill-session'],

        components: {
            Action
        },

        props: {
            actions: Array
        },

        methods: {
            emitAction: function(action, e) {
                this.$emit(action, e);
            }
        }
    }
</script>